import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router"
import { z } from "zod"

import { facilitiesQueryOptions } from "../../../../features/facilities/queries"

const facilitiesearchSchema = z.object({
  search: z.coerce.string().optional().catch(""),
  facilityType: z.coerce.number().optional().catch(undefined),
  page: z.coerce.number().catch(1),
  pageSize: z.coerce.number().catch(10),
})

export const Route = createFileRoute("/_app/manage/facilities/")({
  validateSearch: (search: SearchSchemaInput) =>
    facilitiesearchSchema.parse(search),
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => {
    return context.queryClient.ensureQueryData(
      facilitiesQueryOptions({ params: { query: deps } })
    )
  },
})
